import { Message } from 'element-ui'

export function showError(mensaje) {
  setTimeout(() => Message.error({ message: mensaje, duration: 0, showClose: true }), 0)
}

export function showSuccess(mensaje) {
  setTimeout(() => Message.success({ message: mensaje, duration: 5000, showClose: true }), 0)
}

export function showWarning(mensaje) {
  setTimeout(() => Message.warning({ message: mensaje, duration: 0, showClose: true }), 0)
}